export const getProcessDescendants = (processId, processes) => {
    const descendants = processes.filter(process => process.parentProcessId === processId);
    
    for (const descendant of descendants) {
        descendants.push(...getProcessDescendants(descendant.id, processes));
    }

    return descendants;
}

/**
 * Retrieves the ancestor processes of a given process ID from an array of processes.
 * @param {string} processId - The ID of the process to retrieve the ancestors for.
 * @param {Array} processes - The array of processes to search in.
 * @returns {Array} - An array containing the ancestor processes, including the process itself. Starting from the process that has its id given to the root process
 */
export const getAncestorProcesses = (processId, processes, untilAndIncludingProcessId=null) => {
    // find process id
    const process = processes.find(proc => proc.id === processId);

    if (!process) {
        console.log("process not found", processId, processes);
    }

    // get parent of process id "parentProcessId"
    const parentProcessId = process.parentProcessId;

    // check if the current process is the one we should stop at
    if (processId === untilAndIncludingProcessId) {
        return [process];
    }

    // recursively run the function until the parent is null or we reach the untilAndIncludingProcessId
    if (parentProcessId === null || parentProcessId === untilAndIncludingProcessId) {
        // return the ancestry
        return [process];
    } else {
        return [process, ...getAncestorProcesses(parentProcessId, processes, untilAndIncludingProcessId)];
    }
}